import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem
} from '@mui/material';
import { Income } from 'common/entities';
import { useAppDispatch, useAppSelector } from 'core/hooks/hooks';
import { useContextMenu } from 'core/hooks/useContextMenu';
import { IEntityContext } from 'core/hooks/useEntityContext';
import { useNotificationContext } from 'core/providers/NotificationContextProvider';
import { deleteBudget } from 'core/store/actions/budgets.actions';
import { budgetsSelector } from 'core/store/selectors/budgets.selector';
import { useCallback, useEffect } from 'react';
import { IncomesListItem } from './IncomeListItem';

export interface IncomesListProps {
  context: IEntityContext<string>;
  openEditForm: () => void;
  incomes: Income[];
}

const IncomesList = ({ context, openEditForm, incomes }: IncomesListProps) => {
  const { showNotification } = useNotificationContext();
  const dispatch = useAppDispatch();
  const contextMenu = useContextMenu(context);
  const { lastAction, error } = useAppSelector(budgetsSelector);

  useEffect(() => {
    switch (lastAction) {
      case deleteBudget.fulfilled.type:
        showNotification({
          message: `Income has been deleted`
        });
        break;
      case deleteBudget.rejected.type:
        showNotification({ isError: true, message: `Error: ${error}` });
        break;
    }
  }, [lastAction]);

  const onOpenEditForm = () => {
    contextMenu.hideMenu();
    openEditForm();
  };

  const renderItemMenu = useCallback(() => {
    const handleDeleteBudget = () => {
      context.current && dispatch(deleteBudget(context.current));
      contextMenu.closeMenu();
    };

    return (
      <Menu
        open={contextMenu.menuOpen}
        anchorEl={contextMenu.anchorEl}
        onClose={contextMenu.closeMenu}
      >
        <MenuItem onClick={onOpenEditForm}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Edit</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleDeleteBudget}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem>
      </Menu>
    );
  }, [context]);

  return (
    <>
      <List>
        {incomes.map(i => (
          <ListItem sx={{ p: 0, mb: 2 }} key={i.id}>
            <IncomesListItem income={i} onMenuClick={contextMenu.menuClick} />
          </ListItem>
        ))}
      </List>
      {renderItemMenu()}
    </>
  );
};

export default IncomesList;
